import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9V10H8V9Z" stroke="#C2C2C2" strokeWidth="2" />
      <rect x="6" y="10" width="12" height="10" rx="2" stroke="#C2C2C2" strokeWidth="2" />
      <rect x="11" y="13" width="2" height="4" rx="1" fill="#C2C2C2" />
    </svg>
  );
};

export default Svg;
